import { OperatingHours } from '@leverege/operating-hours'
import { Attributes } from '@leverege/ui-attributes'
import { DateTime } from 'luxon'
import { useMemo } from 'react'

export default function useStackedBarGroupData( {
  businessDays,
  data,
  openHours,
  stationNames,
  operatingHours
} ) {

  return useMemo( () => {
    const timezone = OperatingHours.getTimezone( operatingHours )
    const ret = businessDays.reduce( ( acc, day ) => {
      const [ start ] = day
      const date = DateTime.fromMillis( start )
      const monthDay = `${date.toFormat( 'EEE' )} ${date.month}/${date.day}`

      acc[monthDay] = {
        date : monthDay
      }

      openHours.forEach( ( hour ) => {
        const formattedStart = DateTime.now().set( { hour } ).startOf( 'hour' ).toFormat( 'hh:mma' )
        const formattedEnd = DateTime.now().set( { hour : Number( hour ) + 1 } ).startOf( 'hour' ).toFormat( 'hh:mma' )
        const formattedHour = `${formattedStart} - ${formattedEnd}`
        
        acc[monthDay][hour] = {
          count : 0,
          hour,
          formattedHour
        }

        stationNames.forEach( ( name ) => {
          acc[monthDay][hour][name] = 0
        } )
      } )

      return acc
    }, {} )
    
    data.forEach( ( datum, i ) => {
      const { startTime, obj } = datum
      const date = DateTime
        .fromMillis( startTime )
        .setZone( timezone )
      const monthDay = `${date.toFormat( 'EEE' )} ${date.month}/${date.day}`
      const hour = `${date.hour}`
      // const number = obj?.data?.data?.number

      // if ( number != null ) {
      const name = Attributes.get( 'name', obj ) || obj.data?.name
      if ( ret?.[monthDay]?.[hour] != null ) {
        ret[monthDay][hour].count += 1
        ret[monthDay][hour][name] += 1
      }
      // } else {
      //   console.warn( `Station ${obj?.data?.name || obj?.id} has no number assigned and is not contributing to statistics` )
      // }
    } )
          
    return Object.values( ret )
  }, [ data, businessDays, openHours, stationNames, operatingHours ] )
}
